import { fetchApi } from './client'

export type BuilderMode = 'gemini' | 'docker-builder'

export interface CodeGenJob {
  id: string
  phenotypeId: string
  status: 'pending' | 'running' | 'completed' | 'failed'
  triggerAfter: string
  triggeredBy: string | null
  startedAt: string | null
  completedAt: string | null
  errorMessage: string | null
  extractorCode: string | null
  testResultsJson: string | null
  builderMode: BuilderMode
  createdAt: string
  updatedAt: string
}

export interface ExampleTestResult {
  fileId: string
  passed: boolean
  expected: unknown
  actual: unknown
  error?: string
}

export async function getCodegenJob(jobId: string): Promise<CodeGenJob> {
  const response = await fetchApi<{ job: CodeGenJob }>(`/api/v1/codegen/${jobId}`)
  return response.job
}

export async function getCodegenJobByPhenotype(phenotypeId: string): Promise<CodeGenJob | null> {
  const response = await fetchApi<{ job: CodeGenJob | null }>(
    `/api/v1/codegen?phenotypeId=${encodeURIComponent(phenotypeId)}`
  )
  return response.job
}

export async function triggerCodegen(
  phenotypeId: string,
  mode: BuilderMode = 'docker-builder'
): Promise<{ jobId: string; status: string; debounced?: boolean }> {
  return fetchApi('/api/v1/codegen/trigger', { method: 'POST', body: { phenotypeId, mode } })
}
